module.exports = __webpack_public_path__ + "static/alarm-45d70c21db4a8d67407bff84e1d786aa.mp3";